import { render, staticRenderFns } from "./DiscretionaryAdjustment.vue?vue&type=template&id=263a2bae&scoped=true"
import script from "./DiscretionaryAdjustment.vue?vue&type=script&lang=js"
export * from "./DiscretionaryAdjustment.vue?vue&type=script&lang=js"
import style0 from "./DiscretionaryAdjustment.vue?vue&type=style&index=0&id=263a2bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263a2bae",
  null
  
)

export default component.exports